<template>
  <div class="msg-datetime">
    <span>{{ format }}</span>
  </div>
</template>

<script>
export default {
  props: {
    data: Object,
  },
  computed: {
    format() {
      const date = new Date(this.data.time);
      const year = date.getFullYear();
      const month = date.getMonth();
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      // const seconds = date.getSeconds();

      const today = new Date();
      const sameYear = year === today.getFullYear();
      // const sameDay = month === today.getMonth() && day === today.getDate();

      return [
        sameYear ? '' : `${year}-`,
        `${month + 1}-`,
        `${day}`,
        ' ',
        `${hours}:`,
        `${minutes}`,
      ]
        .join('')
        .replace(/\b(\d)\b/g, '0$1');
    },
  },
};
</script>

<style lang="less" scoped>
.msg-datetime{
  color: #a1abc2;
}
.msg-datetime {
  &.pc.pc-not-frame {
    span {
      padding: 2px 12px;
      border-radius: 6px;
      background-color: rgba(255, 255, 255, 0.4);
    }
  }
}
</style>
